import React from 'react';
import FaIcon from '../Elements/FaIcon';
import PlanningStatusEnum from '../Enums/PlanningStatusEnum';
import stringHelper from './stringHelper';
import dateTimeHelper from './datetimeHelper';

export class statusHelper {
  static getPlanningStatusColorClassName(status) {
    let res = ' planningStatus' + status;
    return res;
  }

  static getStatusColorIcon(status) {
    let cn = statusHelper.getPlanningStatusColorClassName(status);

    if (status === 'Waiting...') {
      return (
        <FaIcon
          iconName='fa-solid fa-pause'
          className='text-warning'
        />
      );
    }

    return <FaIcon className={cn} />;
  }

  static getToSelectValues() {
    let values = [
      { label: PlanningStatusEnum.Created, value: PlanningStatusEnum.Created, disabled: false },
      { label: PlanningStatusEnum.ClientConfirmed, value: PlanningStatusEnum.ClientConfirmed, disabled: false },
      { label: PlanningStatusEnum.OnField, value: PlanningStatusEnum.OnField, disabled: false },
      { label: PlanningStatusEnum.OnHold, value: PlanningStatusEnum.OnHold, disabled: false },
      { label: PlanningStatusEnum.Closed, value: PlanningStatusEnum.Closed, disabled: false },
      { label: PlanningStatusEnum.Cancelled, value: PlanningStatusEnum.Cancelled, disabled: false },
    ];
    return values;
  }

  static getForwardStatus(item) {
    const plannedIsZero = item.NumberOfPlannedAssignments === 0;
    const startsTodayOrEarlier = dateTimeHelper.toYYYYsMMsDD(item.StartDate) <= dateTimeHelper.toYYYYsMMsDD(new Date());
    return plannedIsZero || startsTodayOrEarlier ? PlanningStatusEnum.Created : PlanningStatusEnum.ClientConfirmed;
  }

  static getToSelectValuesForItem(item, isAdmin) {
    const toOption = (status) => ({ label: stringHelper.convertToWords(status).trim(), value: status });
    switch (item.CurrentStatus) {
      case PlanningStatusEnum.Created:
        return [toOption(PlanningStatusEnum.OnHold), toOption(PlanningStatusEnum.Cancelled)];
      case PlanningStatusEnum.ClientConfirmed:
        return [
          toOption(PlanningStatusEnum.OnField),
          toOption(PlanningStatusEnum.Closed),
          toOption(PlanningStatusEnum.OnHold),
          toOption(PlanningStatusEnum.Cancelled),
        ];
      case PlanningStatusEnum.OnField:
        return [
          toOption(PlanningStatusEnum.Closed),
          toOption(PlanningStatusEnum.OnHold),
          toOption(PlanningStatusEnum.Cancelled),
        ];
      case PlanningStatusEnum.Closed:
        return isAdmin ? [toOption(PlanningStatusEnum.OnHold)] : [];
      case PlanningStatusEnum.OnHold:
        return [toOption(statusHelper.getForwardStatus(item)), toOption(PlanningStatusEnum.Cancelled)];
      case PlanningStatusEnum.Cancelled:
        return [toOption(statusHelper.getForwardStatus(item)), toOption(PlanningStatusEnum.OnHold)];
      default:
        return [];
    }
  }

  static getFromInfoParts(newStatus) {
    let statusInReality =
      newStatus === PlanningStatusEnum.Created || newStatus === PlanningStatusEnum.ClientConfirmed
        ? 'Created or Client Confirmed (depends on their properties)'
        : stringHelper.convertToWords(newStatus);
    let affectedStatuses = '';
    switch (newStatus) {
      case PlanningStatusEnum.Created:
        affectedStatuses = 'On Hold, Cancelled';
        break;
      case PlanningStatusEnum.ClientConfirmed:
        affectedStatuses = 'On Hold, Cancelled';
        break;
      case PlanningStatusEnum.OnField:
        affectedStatuses = 'Client Confirmed';
        break;
      case PlanningStatusEnum.Closed:
        affectedStatuses = 'Client Confirmed, On Field';
        break;
      case PlanningStatusEnum.OnHold:
        affectedStatuses = 'Created, Client Confirmed, On Field, Cancelled';
        break;
      case PlanningStatusEnum.Cancelled:
        affectedStatuses = 'Created, Client Confirmed, On Field, On Hold';
        break;

      default:
        break;
    }
    return { statusInReality, affectedStatuses };
  }

  static getFromInfo(newStatus) {
    let { statusInReality, affectedStatuses } = statusHelper.getFromInfoParts(newStatus);
    return (
      <>
        {'The following statuses will change to ' + statusInReality + ': '}
        <br />
        {affectedStatuses}
      </>
    );
  }

  // Paragraph form of getFromInfo for the InfoCallout wizard input (window
  // descriptions can't carry JSX). First paragraph bolds the target status via
  // the **marker** convention parsed by InfoCalloutField.
  static getFromInfoParagraphs(newStatus) {
    let { statusInReality, affectedStatuses } = statusHelper.getFromInfoParts(newStatus);
    return [
      `The following statuses will change to **${statusInReality}**:`,
      affectedStatuses,
      statusHelper.getDateLockNote(newStatus),
    ].filter(Boolean);
  }

  // Moving to On Field settles the window the fieldwork runs in, so the dates are locked with it.
  // Worth saying up front: unlocking them again needs the date-lock override role.
  static getDateLockNote(newStatus) {
    return newStatus === PlanningStatusEnum.OnField ? 'Their fieldwork start and end dates will be locked.' : '';
  }
}

export default statusHelper;
